@if (loading) {
<p>
  Loading Hemisphere, please wait...
</p>
}

@if (!loading) {
<div style="margin:100px auto; width: 800px;">
  <div>
    <label>FastForward:</label>
    <input type="checkbox" [checked]="fastForward" (click)="toggleFastForward($event)" />
  </div>
  <div>
    <label>Don't send actions/reminders:</label>
    <input type="checkbox" [checked]="sentActions" (click)="toggleSentActions($event)" />
  </div>
  <table>
    @for (step of steps; track step; let i = $index) {
    <tr style="text-align:left;" (click)="this.controller.resume(step.step)">
      <td>{{i}}</td>
      <td>{{step.route}}</td>
      <td>{{step.description}}</td>
    </tr>
    }
  </table>
</div>
}